import React from "react";
import {Route, Routes} from "react-router-dom";
import Blacklists from "../pages/Blacklist/Blacklists";
import BuildersLanding from "../pages/Builders/BuildersLanding";
import CompanyDetailsForm from "../pages/Company/CompanyDetailsForm";
import Comparison from "../pages/Comparison/Comparison";
import ETFMatrix from "../pages/EtfMatrix/EtfMatrix";
import FactSheet from "../pages/Portfolio/FactSheet/FactSheet";
import Files from "../pages/Files/Files";
import {default as PortfolioFormBuilder} from "../pages/FormBuilder/FormBuilder";
import Dashboard from "../pages/Dashboard";
import PerformanceComparison from "../pages/PerformanceComparison/PerformanceComaprison";
import PortfolioBuilder from "../SuperComponents/PortfolioBuilder/PortfolioBuilder";
import PortfoliosCollection from "../pages/Portfolio/PortfoliosCollection";
import PortfolioPages  from "../pages/Portfolio/PortfolioPages/PortfolioPages";
import PageViewHistory from "../pages/Portfolio/PortfolioPages/PageViewHistory";
import PortfolioPagePublicEntrypoint from "../pages/PublicPages/PortfolioPagePublicEntrypoint";
import PortfolioSignals from "../pages/TradingSignals/components/PortfolioSignals";
import PortfolioView from "../pages/PortfolioView/PortfolioView";
import Resources from "../pages/Resources/Resources";
import Screens from "../pages/Screens/Screens";
import Settings from "../pages/Settings/Settings";
import Sma from "../pages/SmaV2/Sma";
import Snapshots from "../pages/TradingSignals/Snapshots/Snapshots";
import SuperUser from "../pages/SuperUser/SuperUser";
import Touchpoints from "../pages/Touchpoints/Touchpoints";
import TradingSignals from "../pages/TradingSignals/TradingSignals";
import TickerView    from "../pages/TickerView/TickerView";
import TickerCalendar from "../pages/TickerCalendar/TickerCalendar";



import AttributionModel from "../SuperComponents/Beta/AttributionModel";
import GeneralStockChart from "../SuperComponents/StockCharts/GeneralStockChart";
import InteractiveRisk from "../SuperComponents/Beta/InteractiveRisk";
import TickerLauncher from "../pages/Experiments/TickerLauncher";

import FactorView from "../pages/Experiments/FactorView";

import XrayLauncher from "../pages/Experiments/XrayLauncher";
import BetaLauncher from "../pages/Experiments/BetaLauncher";


export const PublicRoutes = () => {
    return (
            <Routes>
                {/* Define public routes here */}
                <Route path="/public/portfolio/:portfolioId" element={<PortfolioView/>}/>
                <Route path="/public/etfs/matrix" exact element={<ETFMatrix/>}/>
                <Route path={'/public/pages/:pageId'} element={<PortfolioPagePublicEntrypoint/>} />
                <Route path={'/public/etf-matrix'} element={<ETFMatrix/>}/>
                <Route path={'/public/resources'} element={<Resources/>}/>
                <Route path={'/public/builders/sma'} element={<Sma/>}/>

                {/* You can add more public routes as needed */}
            </Routes>
    )
}


export const IAPlatformRoutes = ({widgets}) => {
    return (
        <Routes>
            <Route path="/"  exact element={<Dashboard widgets={widgets} />} />
            <Route path="/builders/landing" exact element={<BuildersLanding />} />
            <Route path="/builders/portfolio" exact element={<PortfolioBuilder />} />
            <Route path="/builders/model" exact element={<PortfolioFormBuilder />} />
            <Route path="/builders/sma" exact element={<Sma />} />
            <Route path="/builders/sma/v2" exact element={<Sma />} />


            <Route path={"/company/details/edit"} exact element={<CompanyDetailsForm/>} />
            <Route path="/etfs/matrix" exact element={<ETFMatrix />} />

            <Route path="/files" exact element={<Files/>} />


            <Route path="/pages" exact element={<PortfolioPages />} />
            <Route path="/pages/:pageId/views" element={<PageViewHistory />} />
            <Route path="/portfolios" element={<PortfoliosCollection />} />
            <Route path="/portfolio/:portfolioId" element={<PortfolioView />} />
            <Route path="/portfolio/:portfolioId/factsheet" element={<FactSheet />} />

            <Route path="/signals" exact element={<TradingSignals />} />
            <Route path="/signals/:portfolioId" element={<PortfolioSignals />} />
            <Route path="/signals/:portfolioId/history" element={<Snapshots />} />

            <Route path="/performance/comparison" exact element={<PerformanceComparison />} />
            <Route path={'/resources'} exact element={<Resources/>}/>
            <Route path="/screener" exact element={<Screens />} />

            <Route path="/widgets/blacklist" exact element={<Blacklists />} />

            <Route path="/settings" exact element={<Settings />} />
            <Route path="/superuser" exact element={<SuperUser />} />
            <Route path={'/beta/touchpoints'} exact element={<Touchpoints />} />
            <Route path={'/beta/comparison'} exact element={<Comparison/>} />
            <Route path={'/beta/general/chart'} exact element={<GeneralStockChart/>} />
            <Route path={'/beta/interactive-risk'} exact element={<InteractiveRisk/>} />
            <Route path="/tickers/:ticker" exact element={<TickerView/>} />
            <Route path="/beta/attribution" element={<AttributionModel />} />
            <Route path="/experiments/home" element={<TickerLauncher/>} />
            <Route path='/markets/factors' element={<FactorView/>} />
            <Route path="/calendar" element={<TickerCalendar/>} />

            <Route path="/beta/xray" element={<XrayLauncher/>} />
            <Route path="/beta/launcher" element={<BetaLauncher/>} />

        </Routes>
    )
};


